// src/config/constants.js

// Gramvey WebSocket URL
export const WEBSOCKET_URL = 'https://www.livepriceofgold.com/FX/turkey.json?1785955970309';

// Gramvey REST API Base URL
export const GRAMVEY_API_URL = 'https://www.livepriceofgold.com/FX/turkey.json?1785955970309';

// Gold types from Gramvey
export const GOLD_TYPES = {
  GRAM_24K: 'gram-altin',      // 24K Gold per gram
  GRAM_22K: '22-ayar-bilezik', // 22K Gold per gram
  OUNCE: 'ons-altin',          // Gold per ounce
  GRAM_18K: '18-ayar-bilezik', // 18K Gold per gram
  QUARTER: 'ceyrek-altin',     // Quarter Gold Coin
  HALF: 'yarim-altin',         // Half Gold Coin
  FULL: 'tam-altin',           // Full Gold Coin
  REPUBLIC: 'cumhuriyet-altini', // Republic Gold Coin
  SILVER_GRAM: 'gram-gumus',   // Silver per gram
};

// Gold display names
export const GOLD_DISPLAY_NAMES = {
  'gram-altin': 'Gold (24K)',
  '22-ayar-bilezik': 'Gold (22K)',
  'ons-altin': 'Gold (Ounce)',
  '18-ayar-bilezik': 'Gold (18K)',
  'ceyrek-altin': 'Quarter Gold',
  'yarim-altin': 'Half Gold',
  'tam-altin': 'Full Gold',
  'cumhuriyet-altini': 'Republic Gold',
  'gram-gumus': 'Silver',
};

export const PRODUCTS_DATA = [
  // Gold Products
  { id: 1, name: 'Gold Coin', weight: '10g', purity: '24K', price: 850, category: 'gold', image: '🪙', labourCharge: 50 },
  { id: 2, name: 'Gold Coin', weight: '20g', purity: '24K', price: 1700, category: 'gold', image: '🪙', labourCharge: 75 },
  { id: 3, name: 'Gold Coin', weight: '50g', purity: '24K', price: 4250, category: 'gold', image: '🪙', labourCharge: 150 },
  { id: 4, name: 'Gold Bar', weight: '100g', purity: '999.9', price: 8500, category: 'gold', image: '🏆', labourCharge: 250 },
  { id: 5, name: 'Gold Bar', weight: '200g', purity: '999.9', price: 17000, category: 'gold', image: '🏆', labourCharge: 400 },
  { id: 6, name: 'Gold Bar', weight: '500g', purity: '999.9', price: 42500, category: 'gold', image: '🏆', labourCharge: 750 },
  { id: 7, name: 'Gold Bar', weight: '1kg', purity: '999.9', price: 85000, category: 'gold', image: '🏆', labourCharge: 1200 },
  { id: 8, name: 'Gold Bar', weight: '2kg', purity: '999.9', price: 170000, category: 'gold', image: '🏆', labourCharge: 2000 },
  { id: 9, name: 'Gold Bar', weight: '5kg', purity: '999.9', price: 425000, category: 'gold', image: '🏆', labourCharge: 4000 },
  { id: 10, name: 'Gold Bar', weight: '30kg', purity: '999.9', price: 2550000, category: 'gold', image: '🏆', labourCharge: 15000 },
  
  // Silver Products
  { id: 11, name: 'Silver Coin', weight: '100g', purity: '999', price: 120, category: 'silver', image: '/Product-1.png', labourCharge: 20 },
  { id: 12, name: 'Silver Bar', weight: '1kg', purity: '999', price: 1200, category: 'silver', image: '/Product-2.png', labourCharge: 100 },
  { id: 13, name: 'Silver Coin', weight: '200gm', purity: '999', price: 1200, category: 'silver', image: '/Product-3.png', labourCharge: 100 },
  { id: 14, name: 'Silver Bar', weight: '1kg', purity: '999', price: 1200, category: 'silver', image: '/Product-4.png', labourCharge: 100 },
];

export const LABOUR_CHARGES = {
  '10g': 50,
  '20g': 75,
  '50g': 150,
  '100g': 250,
  '200g': 400,
  '500g': 750,
  '1kg': 1200,
  '2kg': 2000,
  '5kg': 4000,
  '30kg': 15000,
};